export default {
  "wrapper": "_wrapper_1thsf_1",
  "card": "_card_1thsf_5",
  "name": "_name_1thsf_18",
  "nameHidden": "_nameHidden_1thsf_31"
};import "ni:sha-256;okmj6Td_uCkcf1-xkcQHAIE5hLCElK-5XxOf76mfM60";